import type { PipelineLanguage } from '../api';

export const languages: OptionType<
  | `${PipelineLanguage}`
  | 'af'
  | 'am'
  | 'az'
  | 'bg'
  | 'bn'
  | 'ca'
  | 'cmn'
  | 'cs'
  | 'cy'
  | 'el'
  | 'et'
  | 'eu'
  | 'fa'
  | 'fi'
  | 'ga'
  | 'gd'
  | 'gl'
  | 'gu'
  | 'ha'
  | 'he'
  | 'hr'
  | 'hu'
  | 'hy'
  | 'is'
  | 'jv'
  | 'ka'
  | 'kk'
  | 'km'
  | 'kn'
  | 'ky'
  | 'lb'
  | 'lo'
  | 'lt'
  | 'lv'
  | 'mg'
  | 'mk'
  | 'ml'
  | 'mn'
  | 'mr'
  | 'ms'
  | 'mt'
  | 'ne'
  | 'nl-BE'
  | 'or'
  | 'pa'
  | 'ps'
  | 'ro'
  | 'rw'
  | 'si'
  | 'sk'
  | 'sl'
  | 'so'
  | 'sq'
  | 'sr'
  | 'st'
  | 'su'
  | 'sw'
  | 'taq'
  | 'te'
  | 'tl'
  | 'tt'
  | 'ur'
  | 'ur-IN'
  | 'ur-PK'
  | 'uz'
  | 'vi'
  | 'xh'
  | 'yo'
  | 'yue'
  | 'zu'
>[] = [
  { value: 'af', label: 'Afrikaans' },
  { value: 'am', label: 'Amharic' },
  { value: 'ar', label: 'Arabic' },
  { value: 'az', label: 'Azerbaijani' },
  { value: 'bg', label: 'Bulgarian' },
  { value: 'bn', label: 'Bangla/Bangladesh' },
  { value: 'ca', label: 'Catalan' },
  { value: 'cmn', label: 'Chinese (Mandarin)' },
  { value: 'cs', label: 'Czech' },
  { value: 'cy', label: 'Welsh' },
  { value: 'da', label: 'Danish' },
  { value: 'de', label: 'German' },
  { value: 'el', label: 'Greek' },
  { value: 'en', label: 'English' },
  { value: 'en-AU', label: 'English (Australia)' },
  { value: 'en-GB', label: 'English (United Kingdom)' },
  { value: 'en-IN', label: 'English (India)' },
  { value: 'en-NZ', label: 'English (New Zealand)' },
  { value: 'en-US', label: 'English (United States)' },
  { value: 'es', label: 'Spanish' },
  { value: 'es-419', label: 'Spanish (Latin America)' },
  { value: 'es-LATAM', label: 'Spanish (Latin America)' },
  { value: 'et', label: 'Estonian' },
  { value: 'eu', label: 'Basque' },
  { value: 'fa', label: 'Persian' },
  { value: 'fi', label: 'Finnish' },
  { value: 'fr', label: 'French' },
  { value: 'fr-CA', label: 'French (Canada)' },
  { value: 'ga', label: 'Irish' },
  { value: 'gd', label: 'Scottish Gaelic' },
  { value: 'gl', label: 'Galician' },
  { value: 'gu', label: 'Gujarati' },
  { value: 'ha', label: 'Hausa' },
  { value: 'he', label: 'Hebrew' },
  { value: 'hi', label: 'Hindi' },
  { value: 'hi-Latn', label: 'Hindi (Latin)' },
  { value: 'hr', label: 'Croatian' },
  { value: 'hu', label: 'Hungarian' },
  { value: 'hy', label: 'Armenian' },
  { value: 'id', label: 'Indonesian' },
  { value: 'is', label: 'Icelandic' },
  { value: 'it', label: 'Italian' },
  { value: 'ja', label: 'Japanese' },
  { value: 'jv', label: 'Javanese' },
  { value: 'ka', label: 'Georgian' },
  { value: 'kk', label: 'Kazakh' },
  { value: 'km', label: 'Khmer' },
  { value: 'kn', label: 'Kannada' },
  { value: 'ko', label: 'Korean' },
  { value: 'ky', label: 'Kyrgyz' },
  { value: 'lb', label: 'Luxembourgish' },
  { value: 'lo', label: 'Lao' },
  { value: 'lt', label: 'Lithuanian' },
  { value: 'lv', label: 'Latvian' },
  { value: 'mg', label: 'Malagasy' },
  { value: 'mk', label: 'Macedonian' },
  { value: 'ml', label: 'Malayalam' },
  { value: 'mn', label: 'Mongolian' },
  { value: 'mr', label: 'Marathi' },
  { value: 'ms', label: 'Malay' },
  { value: 'mt', label: 'Maltese' },
  { value: 'ne', label: 'Nepali' },
  { value: 'nl', label: 'Dutch' },
  { value: 'nl-BE', label: 'Flemish (Dutch - Belgium)' },
  { value: 'no', label: 'Norwegian' },
  { value: 'or', label: 'Odia' },
  { value: 'pa', label: 'Punjabi' },
  { value: 'pl', label: 'Polish' },
  { value: 'ps', label: 'Pashto' },
  { value: 'pt', label: 'Portuguese' },
  { value: 'pt-BR', label: 'Portuguese (Brazil)' },
  { value: 'ro', label: 'Romanian' },
  { value: 'ru', label: 'Russian' },
  { value: 'rw', label: 'Kinyarwanda' },
  { value: 'si', label: 'Sinhala' },
  { value: 'sk', label: 'Slovak' },
  { value: 'sl', label: 'Slovenian' },
  { value: 'so', label: 'Somali' },
  { value: 'sq', label: 'Albanian' },
  { value: 'sr', label: 'Serbian' },
  { value: 'st', label: 'Sotho' },
  { value: 'su', label: 'Sundanese' },
  { value: 'sv', label: 'Swedish' },
  { value: 'sw', label: 'Swahili' },
  { value: 'ta', label: 'Tamil' },
  { value: 'taq', label: 'Tamasheq' },
  { value: 'te', label: 'Telugu' },
  { value: 'th', label: 'Thai' },
  { value: 'tl', label: 'Tagalog' },
  { value: 'tr', label: 'Turkish' },
  { value: 'tt', label: 'Tatar' },
  { value: 'uk', label: 'Ukrainian' },
  { value: 'ur', label: 'Urdu' },
  { value: 'ur-IN', label: 'Urdu India' },
  { value: 'ur-PK', label: 'Urdu Pakistan' },
  { value: 'uz', label: 'Uzbek' },
  { value: 'vi', label: 'Vietnamese' },
  { value: 'xh', label: 'Xhosa' },
  { value: 'yo', label: 'Yoruba' },
  { value: 'yue', label: 'Cantonese' },
  { value: 'zh', label: 'Chinese' },
  { value: 'zh-CN', label: 'Chinese (Simplified)' },
  { value: 'zh-TW', label: 'Chinese (Traditional)' },
  { value: 'zu', label: 'Zulu' },
];

export const supportedLanguages = languages.filter(
  option => !option.value.includes('-')
);
